import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingScreen from '../components/LoadingScreen';

AuthGuard.propTypes = { children: PropTypes.node };

export default function AuthGuard({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const { pathname } = useLocation();

  if (loading) return <LoadingScreen />;
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: pathname }} replace />;

  return <>{children}</>;
}
